import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const socialLinks = [
  { icon: 'ri-instagram-line', href: 'https://www.instagram.com/zpiritualzwebshop/', label: 'Instagram', color: 'hover:text-pink-400 hover:border-pink-400/50' },
  { icon: 'ri-tiktok-line', href: 'https://www.tiktok.com/@zpiritualz.com', label: 'TikTok', color: 'hover:text-violet-400 hover:border-violet-400/50' },
  { icon: 'ri-facebook-circle-line', href: 'https://www.facebook.com/profile.php?id=61572333684687', label: 'Facebook', color: 'hover:text-fuchsia-400 hover:border-fuchsia-400/50' },
  { icon: 'ri-pinterest-line', href: 'https://www.pinterest.com/spiritualshopnl', label: 'Pinterest', color: 'hover:text-rose-500 hover:border-rose-500/50' },
  { icon: 'ri-whatsapp-line', href: 'https://wa.me/31698765432', label: 'WhatsApp', color: 'hover:text-emerald-400 hover:border-emerald-400/50' },
];

export const Footer = () => {
  const { t } = useTranslation();

  const shopLinks = [
    { key: 'footer_link_blueProtect', path: '/blue-protect' },
    { key: 'footer_link_crystals', path: '/shop?cat=kristallen' },
    { key: 'footer_link_aroma', path: '/shop?cat=aromatherapie' },
    { key: 'footer_link_chakra', path: '/shop?cat=chakra' },
    { key: 'footer_link_supp', path: '/shop?cat=supplementen' },
    { key: 'footer_link_selfcare', path: '/shop?cat=self-care' },
  ];

  const infoLinks = [
    { key: 'footer_link_about', path: '/about' },
    { key: 'footer_link_blog', path: '/blog' },
    { key: 'footer_link_consult', path: '/consultations' },
    { key: 'footer_link_reviews', path: '/reviews' },
    { key: 'footer_link_faq', path: '/faq' },
    { key: 'footer_link_orders', path: '/orders' },
    { key: 'footer_link_contact', path: '/contact' },
    { key: 'footer_link_shipping', path: '/contact' },
  ];

  const shipItems = [
    { icon: 'ri-earth-line', labelKey: 'footer_ship_worldwide', subKey: 'footer_ship_worldwide_sub' },
    { icon: 'ri-truck-line', labelKey: 'footer_ship_fast', subKey: 'footer_ship_fast_sub' },
    { icon: 'ri-package-line', labelKey: 'footer_ship_discreet', subKey: 'footer_ship_discreet_sub' },
    { icon: 'ri-customer-service-line', labelKey: 'footer_ship_contact', subKey: 'footer_ship_contact_sub' },
  ];

  return (
    <footer className="bg-gradient-to-b from-[#0d001f] to-[#050010] border-t border-violet-500/10">
      {/* Social Media Banner */}
      <div className="border-b border-violet-500/10">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-white/40 text-sm">
              {t('footer_followText')}{' '}
              <span className="text-violet-300/60">{t('footer_shamanism')}</span>{' '}
              {t('footer_followEnd')}
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map(s => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  rel="nofollow"
                  className={`w-9 h-9 flex items-center justify-center rounded-full border border-white/10 text-white/40 ${s.color} transition-all duration-300 cursor-pointer`}
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 pt-14 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-5">
              <div className="w-12 h-12 flex items-center justify-center shrink-0">
                <img
                  src="https://public.readdy.ai/ai/img_res/d94d3c69-0f7c-4d5d-8dec-5bce3249b295.png"
                  alt="ZpiritualZ logo"
                  className="w-12 h-12 object-contain"
                />
              </div>
              <span className="text-white font-black text-xl tracking-tight">
                Zpiritual<span className="text-transparent bg-gradient-to-r from-violet-400 to-fuchsia-400 bg-clip-text">Z</span>
              </span>
            </Link>
            <p className="text-white/40 text-sm leading-relaxed mb-6">{t('footer_brandDesc')}</p>
            <div className="flex items-center gap-2.5 flex-wrap">
              {socialLinks.map(s => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  rel="nofollow"
                  className={`w-8 h-8 flex items-center justify-center rounded-full border border-white/10 text-white/40 ${s.color} transition-all duration-300 cursor-pointer`}
                >
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Shop Links */}
          <div>
            <h4 className="text-violet-400 text-xs font-semibold uppercase tracking-widest mb-5">{t('footer_shopTitle')}</h4>
            <ul className="space-y-3">
              {shopLinks.map(l => (
                <li key={l.key}>
                  <Link to={l.path} className="text-white/40 text-sm hover:text-violet-400 transition-colors">
                    {t(l.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Info Links */}
          <div>
            <h4 className="text-violet-400 text-xs font-semibold uppercase tracking-widest mb-5">{t('footer_infoTitle')}</h4>
            <ul className="space-y-3">
              {infoLinks.map(l => (
                <li key={l.key}>
                  <Link to={l.path} className="text-white/40 text-sm hover:text-violet-400 transition-colors">
                    {t(l.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-violet-400 text-xs font-semibold uppercase tracking-widest mb-5">{t('footer_newsletterTitle')}</h4>
            <p className="text-white/40 text-sm mb-4">{t('footer_newsletterDesc')}</p>
            <form
              className="flex flex-col gap-3"
              data-readdy-form
              onSubmit={e => {
                e.preventDefault();
                const form = e.target as HTMLFormElement;
                const emailInput = form.querySelector('input[name="email"]') as HTMLInputElement;
                if (!emailInput?.value) return;
                fetch('https://readdy.ai/api/form/d75eagf5hic0eqh31ko0', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                  body: new URLSearchParams({
                    email: emailInput.value,
                    sender: 'info@zpiritualz.com',
                  }).toString(),
                }).then(() => { emailInput.value = ''; });
              }}
            >
              <input
                type="email"
                name="email"
                placeholder={t('footer_newsletterPlaceholder')}
                className="px-4 py-3 bg-white/5 border border-violet-500/20 rounded-lg text-sm text-white placeholder-white/25 focus:outline-none focus:border-violet-500/50 transition-colors"
              />
              <button
                type="submit"
                className="px-4 py-3 bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white text-sm font-semibold rounded-lg whitespace-nowrap hover:opacity-90 transition-opacity cursor-pointer"
              >
                {t('footer_newsletterBtn')}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Worldwide Shipping Strip */}
      <div className="border-t border-violet-500/10">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-5">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12">
            {shipItems.map(item => (
              <div key={item.labelKey} className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-violet-600/20 shrink-0">
                  <i className={`${item.icon} text-violet-400 text-sm`} />
                </div>
                <div>
                  <p className="text-white/60 text-xs font-semibold">{t(item.labelKey)}</p>
                  <p className="text-white/30 text-xs">{t(item.subKey)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/5 py-6 px-6 lg:px-12">
        <div className="max-w-[1440px] mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/25 text-xs">{t('footer_copyright')}</p>
          <div className="flex items-center gap-6">
            <Link to="/contact" className="text-white/25 text-xs hover:text-white/50 transition-colors">{t('footer_privacy')}</Link>
            <Link to="/contact" className="text-white/25 text-xs hover:text-white/50 transition-colors">{t('footer_terms')}</Link>
            <Link to="/contact" className="text-white/25 text-xs hover:text-white/50 transition-colors">{t('footer_cookies')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
